package tools

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.*
import kotlin.reflect.*

object SearchWrapper {
    fun <L : EFieldList.Entry<I>, I> use(
        vararg fields: KProperty1<I, *>,
        items: List<L>,
        predicate: (L) -> Boolean = { true },
        query: MutableState<TextFieldValue>,
        sort: Comparator<in L>
    ): List<L> {
        return items
            .let { list ->
                val q = query.value.text.trim().lowercase()
                val qNorm = q.norm()
                if (q.length < 2) list.filter(predicate)
                else {
                    list.filter {
                        predicate(it) && fields.any { field ->
                            field.get(it.data).toString().lowercase().let {
                                it.contains(q) || it.norm().contains(qNorm)
                            }
                        }
                    }
                }
            }.sortedWith(sort)
    }

    inline fun <reified I> use(
        vararg fields: KProperty1<I, *>,
        items: List<I>,
        query: MutableState<TextFieldValue>,
        sort: Comparator<in I>
    ): List<I> {
        return items
            .let { list ->
                val q = query.value.text.trim().lowercase()
                val qNorm = q.norm()
                if (q.length < 2) list
                else {
                    list.filter {
                        fields.any { field ->
                            field.get(it).toString().lowercase().let {
                                it.contains(q) || it.norm().contains(qNorm)
                            }

                        }
                    }
                }
            }.sortedWith(sort)
    }

    inline fun <reified I> use(
        fields: (I) -> List<String>,
        items: List<I>,
        query: MutableState<TextFieldValue>,
        sort: Comparator<in I>
    ): List<I> {
        return items
            .let { list ->
                val q = query.value.text.trim().lowercase()
                val qNorm = q.norm()
                if (q.length < 2) list
                else {
                    list.filter {
                        fields(it).any { field ->
                            field.lowercase().let {
                                it.contains(q) || it.norm().contains(qNorm)
                            }

                        }
                    }
                }
            }.sortedWith(sort)
    }
}
